import { render } from "./Costos.vue?vue&type=template&id=ae3e81a8&scoped=true"
import script from "./Costos.vue?vue&type=script&lang=js"
export * from "./Costos.vue?vue&type=script&lang=js"

import "./Costos.vue?vue&type=style&index=0&id=ae3e81a8&scoped=true&lang=css"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae3e81a8"]])

export default __exports__